module.exports = __webpack_public_path__ + "img/wedss4.c359dddc.jpg";